import { PRODUCT_LINE_CODE } from '../../../constants/product-lines-codes';
import { SHIPPING_CONDITION_CODE } from '../../../constants/shipping-conditions-codes';
import { adtWay } from '../../ways/adt-steps-way';
import { retail } from '../../ways/retail.way';
import { rmsWay } from '../../ways/rms.way';

export const repo = {
  [PRODUCT_LINE_CODE.BAG_CEMENT]: {
    [SHIPPING_CONDITION_CODE.DELIVERY]: retail,
  },
  [PRODUCT_LINE_CODE.MULTI_PRODUCT]: {
    [SHIPPING_CONDITION_CODE.DELIVERY]: retail,
  },
  [PRODUCT_LINE_CODE.BAG_CEMENT_AND_MULTI_PRODUCT]: {
    [SHIPPING_CONDITION_CODE.DELIVERY]: retail,
  },
  [PRODUCT_LINE_CODE.READY_MIX]: {
    [SHIPPING_CONDITION_CODE.DELIVERY]: rmsWay,
  },
  [PRODUCT_LINE_CODE.ADMIXTURES]: {
    [SHIPPING_CONDITION_CODE.DELIVERY]: adtWay,
  },
};
